import React, { PropsWithChildren, ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogProps } from '@mui/material';

import { DialogHeader } from './DialogHeader';

interface Props extends Omit<DialogProps, 'open' | 'onClose'> {
  label: string;
  isOpen: boolean;
  actions: ReactNode;
  onClose: VoidFunction;
}

export const CustomDialog = ({
  isOpen,
  onClose,
  actions,
  label,
  children,
  ...dialogProps
}: PropsWithChildren<Props>) => (
  <Dialog open={isOpen} maxWidth="sm" fullWidth onClose={onClose} {...dialogProps}>
    <DialogHeader handleClose={onClose} label={label} />

    <DialogContent dividers>{children}</DialogContent>

    <DialogActions>{actions}</DialogActions>
  </Dialog>
);
